// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__7mXd0","outline":"Button_outline__Uki7k","buttonContent":"Button_buttonContent__CT3jl","loader":"Button_loader__Rl1Gs","spin":"Button_spin__lJDdw"};